import { Card } from '../components/ui/cards'
import outdoorImage from "../assets/use-case-outdoor.jpg";
import indoorImage from "../assets/use-case-indoor.jpg";
import { useContext } from 'react';
import Context from '../../common/components/utils/context';

export const UseCases = () => {
  const context = useContext(Context)
  const images = [outdoorImage, indoorImage];
  const cases = [
      {
        "id": 0,
        "title": "Outdoor Infrastructure Inspection",
        "description": "Field engineers access asset specifications, maintenance history, and sensor data overlaid directly on pipelines, equipment, and facilities—no matter the location.",
        "outcomes": [
          "40% reduction in inspection time",
          "Fewer return visits for missing data",
          "Real-time decision support"
        ]
      },
      {
        "id": 1,
        "title": "Indoor Facility Operations",
        "description": "Maintenance teams navigate complex indoor facilities with AR-guided workflows, viewing equipment manuals, safety protocols, and operational parameters in context.",
        "outcomes": [
          "Faster onboarding for new technicians",
          "Reduced equipment downtime",
          "Enhanced safety compliance"
        ]
      }
    ];
  
  return (
    <section ref={context.homepageSections.useCases} id="use-cases" className="py-20 bg-home-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold bg-gradient-to-r from-home-primary to-home-accent bg-clip-text text-transparent mb-6">
            Real-World Applications
          </h2>
          <p className="text-xl text-home-muted-foreground max-w-2xl mx-auto">
            See how infrastructure leaders use GO-Locate AR™ to transform field operations
          </p>
        </div>

        <div className="space-y-16">
          {cases.map((x) => {
            return (
              <Card
                key={x.id}
                className={`overflow-hidden grid md:grid-cols-2 gap-0 border-l-4 ${
                  x.id % 2 === 0 ? "border-l-home-accent" : "border-l-home-primary"
                } ${x.id % 2 === 1 ? "md:grid-flow-col-dense" : ""}`}
              >
                <div className={`${x.id % 2 === 1 ? "md:col-start-2" : ""} relative overflow-hidden group`}>
                  <img
                    src={images[x.id]}
                    alt={x.title}
                    className="w-full h-full object-cover min-h-[300px] group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-home-primary/10 to-home-accent/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
                <div className={`p-8 flex flex-col justify-center ${x.id % 2 === 1 ? "md:col-start-1" : ""}`}>
                  <h3 className="text-2xl font-bold text-home-foreground mb-4">{x.title}</h3>
                  <p className="text-home-muted-foreground mb-6">{x.description}</p>
                  <div className="space-y-3">
                    <p className="text-sm font-semibold bg-gradient-to-r from-home-primary to-home-accent bg-clip-text text-transparent">
                      Measured outcomes:
                    </p>
                    <ul className="space-y-2">
                      {x.outcomes.map((outcome: string, i: number) => (
                        <li key={i} className="flex items-center gap-2">
                          <div className={`w-2 h-2 rounded-full ${x.id % 2 === 0 ? "bg-home-accent" : "bg-home-primary"}`}></div>
                          <span className="text-home-foreground">{outcome}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
